var e={exports:{}};export{e as __module};
//# sourceMappingURL=index4.js.map
